<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ozNOKt/tc-custom/9781504072779.jpg?1738254628172" alt="This image is the cover for the book Death in Harley Street, The Dr. Priestley Detective Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death in Harley Street, The Dr. Priestley Detective Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>An “extremely clever” mystery about a doctor who appears to have fatally injected himself and a dinner party devoted to detection (<i>The Saturday Review</i>).</b><br/>  <br/> Dr. Richard Mawsley was a happy man and a careful man. So how and why did the Harley Street specialist inject himself with strychnine while in his locked office? There’s no hint that anyone else was at the scene, and the guests at Dr. Lancelot Priestley’s weekly dinner party, including two from Scotland Yard, are determined to figure out what happened.<br/>  <br/> Did he suddenly become despondent, or pick up the wrong bottle? This band of crime-solvers is puzzled indeed, and Priestley is left to wonder if there’s another possibility beyond accident, murder, or suicide . . .<br/>  <br/> “A scientist who turns to crime puzzles for recreation . . . The more difficult they are, the better he likes them.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Rhode, Curtis Evans
      </h2>
      
      <p class="authorDescription body article">John Rhode was born Cecil John Charles Street in 1884. He was the author of 140 novels under the names John Rhode, Miles Burton, and Cecil Wade before his death in 1964.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07ae3dda